import { render, staticRenderFns } from "./ActiveIcon.vue?vue&type=template&id=70ecfe93&scoped=true"
import script from "./ActiveIcon.vue?vue&type=script&lang=js"
export * from "./ActiveIcon.vue?vue&type=script&lang=js"
import style0 from "./ActiveIcon.vue?vue&type=style&index=0&id=70ecfe93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecfe93",
  null
  
)

export default component.exports